// src/components/LoginForm.jsx
import React, { useState, useContext, useMemo, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import usuarioImg from "../img/usuario.png";
import { AuthContext } from "../AuthProvider";

const LoginForm = () => {
  // 1) Estado local
  const [email, setEmail] = useState("");
  const [isFocused, setIsFocused] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  // 2) Del contexto sacamos login() y account
  const { login, account, isLoading } = useContext(AuthContext);

  // 3) Verificar si viene de un login exitoso
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const loginSuccess = params.get('login');
    const error = params.get('error');

    if (error) {
      console.error('[LoginForm] Error en autenticación:', error);
      // Puedes mostrar un mensaje de error al usuario aquí
      return;
    }

    if (loginSuccess === 'success') {
      // console.log('[LoginForm] Login exitoso detectado, redirigiendo a dashboard');
      // Limpiar query params y redirigir
      navigate('/dashboard', { replace: true });
      return;
    }

    // Si ya está autenticado (tiene sesión), redirigir
    if (!isLoading && account) {
      // console.log('[LoginForm] Usuario ya autenticado, redirigiendo a dashboard');
      const from = location.state?.from?.pathname || '/dashboard';
      navigate(from, { replace: true });
    }
  }, [account, isLoading, navigate, location]);

  // 4) Validación simple
  const isEmailValid =
    email.includes("@") &&
    (email.includes("bmespain") || 
    email.includes("isolana") || 
    email.includes("grupo-bmv")||
    email.includes(".es")||
    email.includes(".com")||
    email.includes("villar")||
    email.includes("laespecialista"));

  // 5) Submit dispara login del backend
  const handleSubmit = e => {
    e.preventDefault();
    // console.log('[LoginForm] Iniciando login con Microsoft');
    // Usar la función login del contexto que redirige al backend
    login();
  };

  // Mostrar spinner si está validando autenticación
  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-gray-100">
        <div className="text-center">
          <svg className="h-12 w-12 animate-spin mx-auto text-blue-600" viewBox="0 0 24 24" fill="none">
            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"></path>
          </svg>
          <p className="mt-4 text-gray-600 font-medium">Verificando sesión...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-100 p-5">
      <div className="bg-white shadow-md rounded-md p-8 max-w-md w-full">
        <img
          src={usuarioImg}
          alt="Usuario"
          className="w-40 h-40 mx-auto mb-4"
        />
        <form onSubmit={handleSubmit} className="space-y-6">
          <div className="relative">
            <label
              htmlFor="email"
              className={`absolute left-3 text-gray-500 transition-all duration-300 ${
                isFocused || email
                  ? "text-xs -top-1"
                  : "text-sm top-3 mt-5"
              }`}
            >
              Email
            </label>
            <input
              id="email"
              type="email"
              value={email}
              onFocus={() => setIsFocused(true)}
              onBlur={() => setIsFocused(false)}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full mt-5 px-4 py-2 border rounded-md"
            />
          </div>
          <div className="text-right">
            <button
              type="submit"
              disabled={!isEmailValid}
              className={`w-40 py-2 rounded-md transition ${
                isEmailValid
                  ? "bg-blue-500 text-white hover:bg-blue-600"
                  : "bg-gray-300 text-gray-500 cursor-not-allowed"
              }`}
            >
              Login
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default LoginForm;



// const allowedDomains = [
//   "bmespain.com",
//   "isolana.es",
//   "grupo-bmv.com",
//   "grupo-bmv.es",
// ];

// export default function LoginForm() {
//   const [email, setEmail] = useState("");
//   const [isFocused, setIsFocused] = useState(false);
//   const [isSubmitting, setIsSubmitting] = useState(false);

//   const { account, login } = useContext(AuthContext);
//   const location = useLocation();
//   const navigate = useNavigate();
//   const from = location.state?.from?.pathname || "/dashboard";

//   // Redirige si ya hay sesión
//   useEffect(() => {
//     if (account) {
//       navigate(from, { replace: true });
//     }
//   }, [account, from, navigate]);

//   // Validación: formato email + dominio permitido
//   const isEmailValid = useMemo(() => {
//     // formato básico
//     const basic = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
//     if (!basic) return false;

//     const domain = email.split("@")[1]?.toLowerCase();
//     return allowedDomains.includes(domain);
//   }, [email]);

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     if (!isEmailValid || isSubmitting) return;

//     try {
//       setIsSubmitting(true);
//       // Dispara flujo MSAL (redirect). El guard y el AuthProvider harán el resto.
//       await login(); 
//     } finally {
//       // Nota: en redirect no verás este finally, pero lo dejamos por seguridad.
//       setIsSubmitting(false);
//     }
//   };

//   return (
//     <div className="flex items-center justify-center min-h-screen bg-gray-100 p-5">
//       <div className="bg-white shadow-md rounded-md p-8 max-w-md w-full">
//         <img
//           src={usuarioImg}
//           alt="Usuario"
//           className="w-40 h-40 mx-auto mb-4"
//         />

//         <form onSubmit={handleSubmit} className="space-y-6" noValidate>
//           <div className="relative">
//             <label
//               htmlFor="email"
//               className={`absolute left-3 text-gray-500 transition-all duration-300 ${
//                 isFocused || email ? "text-xs -top-1" : "text-sm top-3 mt-5"
//               }`}
//             >
//               Email corporativo
//             </label>
//             <input
//               id="email"
//               type="email"
//               inputMode="email"
//               autoComplete="email"
//               value={email}
//               onFocus={() => setIsFocused(true)}
//               onBlur={() => setIsFocused(false)}
//               onChange={(e) => setEmail(e.target.value.trim())}
//               className="w-full mt-5 px-4 py-2 border rounded-md"
//               aria-invalid={!isEmailValid && email.length > 0}
//               aria-describedby="email-help"
//               required
//             />
//             <p id="email-help" className="mt-1 text-xs text-gray-500">
//               {/* Debe ser uno de: {allowedDomains.join(", ")} */}
//             </p>
//             {!isEmailValid && email.length > 0 && (
//               <p className="mt-1 text-xs text-red-600">
//                 Email no válido o dominio no permitido.
//               </p>
//             )}
//           </div>

//           <div className="text-right">
//             <button
//               type="submit"
//               disabled={!isEmailValid || isSubmitting}
//               className={`w-40 py-2 rounded-md transition ${
//                 !isEmailValid || isSubmitting
//                   ? "bg-gray-300 text-gray-500 cursor-not-allowed"
//                   : "bg-blue-500 text-white hover:bg-blue-600"
//               }`}
//             >
//               {isSubmitting ? "Redirigiendo..." : "Login"}
//             </button>
//           </div>

//           {/* Botón alternativo (opcional): forzar SSO aunque no pongas email */}
//           {/* <button type="button" onClick={login} className="text-sm underline">
//             Iniciar con Microsoft
//           </button> */}
//         </form>
//       </div>
//     </div>
//   );
// }